export const CancellationType = {
  CARE_INITIATED: 'CARE_INITIATED',
  CONTENT_TOU_VIOLATION_GENERIC: 'CONTENT_TOU_VIOLATION_GENERIC',
  COPYRIGHT_CONTENT: 'COPYRIGHT_CONTENT',
  FEEDBACK_RESOLUTION: 'FEEDBACK_RESOLUTION',
  INAPPROPRIATE_CONTENT: 'INAPPROPRIATE_CONTENT',
  LOW_INVENTORY: 'LOW_INVENTORY',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',
  PAYMENT_FRAUD_DECLINED: 'PAYMENT_FRAUD_DECLINED',
  PAYMENT_PAST_DUE: 'PAYMENT_PAST_DUE',
  SHOPPER_INITIATED: 'SHOPPER_INITIATED',
} as const;
